import * as yup from "yup";

export const VALIDATION_SCHEMA = yup.object({
  name: yup.string().required("This field is required!"),
  email: yup.string().email("Must be a valid email."),
  notification_emails: yup
    .array()
    .of(yup.string().email("Must be a valid email.")),
});
